import { render, staticRenderFns } from "./CompanyConfig.vue?vue&type=template&id=5c80cc83&"
import script from "./CompanyConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyConfig.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports